import React from 'react';
import { Typography } from 'antd';

const { Paragraph, Title, Text } = Typography;

export const PublicOfferContent = () => {
  return (
    <div style={{ 
      padding: '12px 0', 
      maxHeight: '70vh', 
      overflowY: 'auto', 
      paddingRight: '8px' 
    }}>
      <Title level={4} style={{ marginBottom: '16px' }}>
        Публичная оферта веб-сервиса
      </Title>
      
      <Paragraph>
        Настоящая оферта (далее - Оферта) является предложением Индивидуального предпринимателя Натфуллиным Рушаном Рустемовичем (далее - Исполнитель) в адрес пользователя (далее - Пользователь) о заключении договора на оказание услуг (далее - Услуги).
      </Paragraph>
      
      <Title level={5}>1. Общие положения</Title>
      <Paragraph>
        1.1. Оферта считается принятой, если Пользователь оплачивает выбранный тариф, что подтверждает его согласие со всеми условиями данной Оферты.<br />
        1.2. Оферта является публичной и доступна на сайте Исполнителя.
      </Paragraph>
      
      <Title level={5}>2. Услуги</Title>
      <Paragraph>
        2.1. Исполнитель предоставляет Пользователю услуги с возможностью выбора тарифа в соответствии с действующими тарифными планами.
      </Paragraph>
      
      <Title level={5}>3. Порядок расчетов</Title>
      <Paragraph>
        3.1. Оплата Услуг осуществляется на основании счета, выставленного Исполнителем.<br />
        3.2. Оплата производится в рублях, в соответствии с выбранным тарифом.
      </Paragraph>
      
      <Title level={5}>4. Права и обязанности сторон</Title>
      <Paragraph>
        4.1. Исполнитель обязуется:<br />
        - Предоставить Пользователю доступ к Услугам.<br />
        - Обеспечить бесперебойное функционирование сервиса, за исключением случаев, обусловленных техническими сбоями или обстоятельствами непреодолимой силы.
      </Paragraph>
      <Paragraph>
        4.2. Пользователь обязуется:<br />
        - Своевременно производить оплату за Услуги.<br />
        - Соблюдать правила пользования платформой.
      </Paragraph>
      
      <Title level={5}>5. Ответственность сторон</Title>
      <Paragraph>
        5.1. Исполнитель не несет ответственности за возможные убытки Пользователя, возникшие в связи с использованием Услуг.<br />
        5.2. Пользователь несет ответственность за использование сервиса в соответствии с действующим законодательством.
      </Paragraph>
      
      <Title level={5}>6. Срок действия и расторжение</Title>
      <Paragraph>
        6.1. Оферта вступает в силу с момента ее принятия и действует до полного выполнения обязательств сторонами.<br />
        6.2. Оферта может быть расторгнута уведомлением любой из сторон за 30 (тридцать) дней.
      </Paragraph>
      
      <Title level={5}>7. Заключительные положения</Title>
      <Paragraph>
        7.1. Все изменения и дополнения к настоящей Оферте действительны только в письменной форме и подписаны обеими сторонами.<br />
        7.2. Вопросы, не урегулированные данной Офертой, регулируются в соответствии с действующим законодательством Российской Федерации.
      </Paragraph>
      
      <Title level={5}>РЕКВИЗИТЫ ИСПОЛНИТЕЛЯ</Title>
      <Paragraph>
        <Text strong>Полное наименование:</Text> Индивидуальный предприниматель Натфуллин Рушан Рустемович<br />
        <Text strong>Юридический адрес:</Text> 422370, Россия, Респ. Татарстан, р-н Тетюшский, г. Тетюши, ул. Садовая, дом 7<br />
        <Text strong>ИНН:</Text> 163801451347<br />
        <Text strong>ОГРНИП:</Text> 323169000069522<br />
        <Text strong>Электронная почта:</Text> mail@productlab.pro<br />
        <Text strong>Телефон:</Text> 88432490245<br />
        <Text strong>Банковские реквизиты:</Text><br />
        р/с: 40802810720000009604<br />
        к/с: 30101810745374525104<br />
        Банк: ООО "Банк Точка"<br />
        БИК: 044525104<br />
        <Text strong>Адрес банка:</Text> 109456, Россия, Москва, 1-й Вешняковский пр., дом 1, стр. 8, 1 этаж, пом. №43<br />
        <Text strong>Код по ОКВЭД:</Text> 62.01
      </Paragraph>
    </div>
  );
};

